import { Button } from "@/components/ui/button";
import { Trash2, PenLine } from "lucide-react";
import { noImg } from "@/assets";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import vodka from "@/components/icons/menu-management/vodka.svg";
import { calculatePriceWithVAT } from "@/lib/utils";
import moment from "moment";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Link } from "react-router-dom";

const ViewNotice = ({
  crust = false,
  isOpen,
  onClose,
  items,
  link,
  teaCoffee = false,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="!max-w-4xl max-h-[85vh] overflow-hidden">
        <DialogTitle>Notice Details</DialogTitle>
        <div className="flex flex-col gap-5 mt-5 overflow-y-auto pr-2 h-full max-h-[calc(85vh-120px)]">
          <img
            className="rounded-md w-32 h-32 object-cover cursor-pointer flex-shrink-0"
            src={items?.file_manager_url || noImg}
            alt="Item Image"
          />
          <div className="flex-shrink-0">
            <p className="text-base font-medium mb-2">Message</p>
            <p className="text-sm leading-relaxed text-zinc-300 whitespace-normal break-words">{items?.message}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewNotice;
